/* eslint-disable */
import Cookies from "js-cookie";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper/swiper-bundle";
Swiper.use([Navigation, Pagination, Autoplay]);

export default {
  init() {
    // tippy("#no-answer", {
    //   content:
    //     "« Non répondu » correspond aux marques et aux enseignes de distribution qui ne nous ont pas fourni les éléments nécessaires pour procéder à leur évaluation sur un critère donné.",
    // });

    new Swiper(".swiper.swiper-chart", {
      slidesPerView: "auto",
      spaceBetween: 24,
      watchOverflow: true,
      direction: "horizontal",
      // centeredSlides: true,
      // centeredSlidesBounds: true,
      breakpoints: {
        320: {
          slidesPerView: "1",
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
        768: {
          slidesPerView: "2",
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        992: {
          slidesPerView: "3",
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        1280: {
          slidesPerView: "4",
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
      },

      navigation: {
        nextEl: "#section-0 .swiper-next",
        prevEl: "#section-0 .swiper-prev",
      },
    });

    let chartsWrapper = document.querySelector(
      "#section-0 .content-wrapper .head"
    );
    let details = document.querySelector(".details");
    let btnsPopup = document.querySelectorAll(".buttons-wrapper [data-popup]");

    btnsPopup.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let target = btn.dataset.popup;

        openPopup(target);
        btn = document.querySelector(
          `.details .buttons-wrapper [data-popup=${target}]`
        );
        btn.classList.add("is-active");
      });
    });

    let closeBtn = document.querySelector(".close-btn");
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      closePopup();
    });

    function resetPopup() {
      let popupsActive = document.querySelectorAll(`[data-content].is-active`);
      popupsActive.forEach(function (popup) {
        if (popup.classList.contains("is-active")) {
          popup.classList.remove("is-active");
        }
      });

      let activeBtns = document.querySelectorAll(
        ".buttons-wrapper [data-popup].is-active"
      );
      activeBtns.forEach(function (activeBtn) {
        if (activeBtn.classList.contains("is-active")) {
          activeBtn.classList.remove("is-active");
        }
      });
    }

    if (document.querySelector("input.sib-PRENOM-area")) {
      document
        .querySelector("input.sib-PRENOM-area")
        .addEventListener("change", function () {
          let prenom = document.querySelector("input.sib-PRENOM-area").value;
          document.querySelector("input.sib-PRENOM-area").value =
            prenom.charAt(0).toUpperCase() + prenom.slice(1);
        });
    }

    if (document.querySelector("input.sib-NOM-area")) {
      document
        .querySelector("input.sib-NOM-area")
        .addEventListener("change", function () {
          let prenom = document.querySelector("input.sib-NOM-area").value;
          document.querySelector("input.sib-NOM-area").value =
            prenom.charAt(0).toUpperCase() + prenom.slice(1);
        });
    }

    function openPopup(target) {
      resetPopup();

      chartsWrapper.classList.remove("is-active");

      let popup = document.querySelector(`[data-content=${target}]`);
      popup.classList.add("is-active");

      if (!details.classList.contains("is-active")) {
        details.classList.add("is-active");
      }

      details.setAttribute("data-color", target);
      animScore();
    }

    function animScore() {
      let items = document.querySelectorAll(".details-wrapper.is-active .item");

      items.forEach(function (item) {
        item.classList.add("animate");
      });
    }

    function closePopup(target) {
      chartsWrapper.classList.add("is-active");

      let popup = document.querySelector(`[data-content].is-active`);
      popup.classList.remove("is-active");

      if (details.classList.contains("is-active")) {
        details.classList.remove("is-active");
      }

      let items = document.querySelectorAll(".details-wrapper.is-active .item");
      items.forEach(function (item) {
        item.classList.remove("animate");
      });
    }

    let charts = document.querySelectorAll(".chart");
    let chartsInstances = [];

    charts.forEach(function (chart) {
      
      var options = {
        series: chart.dataset.scores.split(",").map(s => parseFloat(s)),
        chart: {
          height: 350,
          type: "radialBar",
        },

        tooltip: {
          enabled: true,
          enabledOnSeries: undefined,
          shared: false,
          followCursor: true,
          intersect: false,
          inverseOrder: false,
          custom: undefined,
          fillSeriesColor: false,
          theme: "light",
          style: {
            fontSize: "12px",
            fontFamily: undefined,
          },
          onDatasetHover: {
            highlightDataSeries: true,
          },
          x: {
            show: false,
            format: "dd MMM",
            formatter: undefined,
          },
          y: {
            formatter: function (
              value,
              { series, seriesIndex, dataPointIndex, w }
            ) {
              return "";
            },
            // formatter: undefined,
            title: {
              formatter: (seriesName) => {
                return chart.getAttribute(`data-${seriesName}`);
              },
            },
          },
          z: {
            show: false,
            formatter: undefined,
            title: "Size: ",
          },
          marker: {
            show: false,
          },
        },

        plotOptions: {
          radialBar: {
            dataLabels: {
              show: false,
              name: {
                show: true,
                fontSize: "16px",
                fontFamily: undefined,
                fontWeight: 600,
                color: undefined,
                offsetY: 10,
              },
              value: {
                show: false,
                fontSize: "14px",
                fontFamily: undefined,
                fontWeight: 400,
                color: undefined,
                offsetY: 16,
                formatter: function (val) {
                  return "";
                },
              },
              total: {
                show: true,
                label: chart.dataset.brand,
                color: "#373d3f",
                fontSize: "25px",
                fontFamily: undefined,
                fontWeight: 800,
                formatter: function (w) {
                  return "";
                },
              },
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        colors: chart.dataset.colors.split(","),
        labels: [
          "Engagement",
          "Approvisionnement",
          "Positionnement",
          "Actions",
        ],
      };

      let chartInstance = new ApexCharts(chart, options);
      chartsInstances.push(chartInstance);
    });

    let observer = new IntersectionObserver(
      function (observables) {
        if (observables[0].isIntersecting) {
          chartsInstances.forEach(function (instance) {
            instance.render();
          });

          observer.unobserve(observables[0].target);
        }
      },
      {
        threshold: [0.8],
      }
    );

    var target = document.querySelector(".swiper-chart");
    observer.observe(target);

    // let wpcf7 = document.querySelector("#form .wpcf7");
    var formBackground = document.getElementById("form");
    // let formContent = document.querySelector("#form .form > .content");
    // let formRemerciement = document.querySelector("#form .form > .thank-you");
    // wpcf7.addEventListener(
    //   "wpcf7mailsent",
    //   function (event) {
    //     formContent.style.display = "none";
    //     formRemerciement.style.display = "block";
    //     formBackground.classList.add("thank");
    //   },
    //   false
    // );

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $("html, body").animate(
              {
                scrollTop: target.offset().top,
              },
              1000,
              function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });

    var toggleForm = document.querySelectorAll("[data-toggle-form]");
    toggleForm.forEach((element) => {
      element.addEventListener("click", function (e) {
        e.preventDefault();
        var form = document.querySelector("#form .form");
        var formFoot = document.querySelector("#form .form-foot");

        if (form.classList.contains("is-active")) {
          formBackground.classList.remove("is-active");
          form.classList.remove("is-active");
          formBackground.classList.remove("thank");
          formFoot.classList.add("is-active");
        } else {
          formBackground.classList.add("is-active");
          form.classList.add("is-active");
          formFoot.classList.remove("is-active");
        }
      });
    });

    // JavaScript to be fired on all pages
    var video1 = document.querySelector(".modal-video video");
    var video2 = document.querySelector(".background-video video");
    // var cookieIntroVideo = Cookies.get("intro-video");

    // if (cookieIntroVideo === "played") {
    //   video1.parentNode.style.display = "none";
    //   video2.play();
    //   document.body.style.overflow = "unset";
    // } else {
    // if (video1) {
    // Cookies.set("intro-video", "played", { expires: 2 });
    // video1.onended = function () {
    // video1.parentNode.style.display = "none";
    // video2.play();
    // document.body.style.overflow = "unset";
    // };
    // }
    // }

    var playVideo = document.querySelector(".play-video");
    if (playVideo) {
      playVideo.addEventListener("click", (e) => {
        video1.parentNode.style.display = "block";
        document.body.style.overflow = "hidden";
        video1.play();

        video1.onended = function () {
          video1.parentNode.style.display = "none";
          video2.play();
          document.body.style.overflow = "unset";
        };
      });
    }

    let titles = new Swiper(".swiper.swiper-titles", {
      direction: "horizontal",
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    let content = new Swiper(".swiper.swiper-content", {
      direction: "horizontal",
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    titles.controller.control = content;
    content.controller.control = titles;

    // Slider ACTUALITES
    var sliderActu = null;
    var sliderActuParams = {
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 15,
          direction: "horizontal",
          centeredSlides: true,
          threshold: 20,
          initialSlide: 1,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 15,
          direction: "horizontal",
          centeredSlides: true,
          threshold: 20,
          initialSlide: 1,
        },
      },

      navigation: {
        nextEl: "#section-3 .swiper-button-next",
        prevEl: "#section-3 .swiper-button-prev",
      },
    };

    function initSliderActu() {
      sliderActu = new Swiper(".swiper.swiper-actu", sliderActuParams);

      if (sliderActu != null) {
        sliderActu.on("click", function (swiper, event) {
          sliderActu.slideTo(swiper.clickedIndex);
        });
      }
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
      initSliderActu();
    }

    window.addEventListener("resize", function (e) {
      if (window.matchMedia("(max-width: 991px)").matches) {
        if (sliderActu != null) {
          sliderActu.disable();
          sliderActu.destroy(false, true);
        }
      } else {
        initSliderActu();
      }
    });

    var actuItems = document.querySelectorAll(".swiper-actu .swiper-slide");
    actuItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        var actuActiveItems = document.querySelectorAll(
          ".swiper-actu .swiper-slide.active"
        );
        actuActiveItems.forEach((activeItem) => {
          activeItem.classList.remove("active");
        });
        if (!item.classList.contains("active")) {
          item.classList.add("active");
        }
      });
    });

    var actuItemsClose = document.querySelectorAll(
      ".swiper-actu .swiper-slide .close"
    );
    actuItemsClose.forEach((item) => {
      item.addEventListener("click", (e) => {
        if (item.parentNode.classList.contains("active")) {
          item.parentNode.classList.remove("active");
        }
        e.preventDefault();
        e.stopPropagation();
      });
    });

    const noAnswerers = document.querySelector(".no-answerers");
    const dots = document.querySelector(".dots");

    if (noAnswerers) {
      dots.addEventListener("click", () => {
        noAnswerers.classList.toggle("no-answerers--expanded");
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js